import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { RequestService } from '../services/request.service';
import {
  PostOptions,
  PutOptions,
  GetOptions,
  DeleteOptions
} from '../services/interfaces/request.interfaces';

import { ModalComponent } from '../components/popups/modal/modal.component';
import { ErrorComponent } from '../components/popups/error/error.component';

import { State } from '../reducers/index';
import { LOGIN_REQUEST } from '../actions/login.action';
import {
  InfoAction,
  INFO_UPDATE,
  INFO_PAYMENT,
  INFO_PAYMENT_SUCCESS,
  INFO_PAYMENT_FAILURE,
  INFO_DATA_SEND,
  INFO_DATA_SEND_SUCCESS,
  INFO_DATA_SEND_FAILURE } from '../actions/info.action';
import {
  BookingAction,
  BOOKING_REQUEST,
  BOOKING_REQUEST_SUCCESS,
  BOOKING_REQUEST_FAILURE
} from '../actions/booking.action';
import { OVERLAY_FINISH } from '../actions/header.action';
import {
  PostCredentialsRequest,
  PostCredentialsResponse,
  PutCredentialsRequest,
  PutCredentialsResponse,
  DeleteCredentialsResponse,
  GetCredentialsResponse } from './interfaces/info.interfaces';


@Injectable()
export class InfoEffect {

  private getOptions: GetOptions<GetCredentialsResponse>;
  private getOptionsToCheckRequest: GetOptions<GetCredentialsResponse>;
  private postOptions: PostOptions<PostCredentialsRequest, PostCredentialsResponse>;
  private deleteOptions: DeleteOptions<DeleteCredentialsResponse>;
  private putOptions: PutOptions<PutCredentialsRequest, PutCredentialsResponse>;
  private actionName: any = {
    success: 'INFO_DATA_SEND_SUCCESS',
    failure: 'INFO_DATA_SEND_FAILURE'
  };

  constructor(
    private dialog: MatDialog,
    private requestService: RequestService,
    private actions$: Actions,
    private router: Router,
    private store: Store<State>
  ) {
    // request configs
    this.postOptions = {
      url: '/online-booking/stripe/customer',
      body: {
        token: null
      },
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this)
      }
    };
    this.getOptions = {
      url: '/online-booking/stripe/customer',
      handlers: {
        success: this.successGet.bind(this),
        error: this.error.bind(this)
      }
    };
    this.deleteOptions = {
      url: '/online-booking/stripe/delete-card',
      handlers: {
        success: this.successDelete.bind(this),
        error: this.error.bind(this)
      }
    };
    this.putOptions = {
      url: `/online-booking/password/${window.location.hash.split('/')[window.location.hash.split('/').length - 1]}`,
      body: {
        password: null
      },
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this)
      }
    };
    this.getOptionsToCheckRequest = {
      url: `/online-booking/${localStorage.getItem('AppId')}/settings`,
      handlers: {
        success: this.successSettingsRequest.bind(this),
        error: this.error.bind(this)
      }
    };
  }
  public successSettingsRequest(response: GetCredentialsResponse): void {
    this.store.dispatch({ type: OVERLAY_FINISH });
    // set widget option or settings
    this.actionName = {
      success: 'INFO_PAYMENT_SUCCESS',
      failure: 'INFO_PAYMENT_FAILURE',
      pay: true
    };
    localStorage.setItem('settings', JSON.stringify(response['settings']));
    if (response['settings'].type !== 'Take full payment') {
      this.postOptions.url = `/online-booking/prepay/pay/${JSON.parse(localStorage.getItem('Appointment')).eventId}?token=${JSON.parse(localStorage.getItem('cardToken')).id}`;
      this.postOptions.body = {
        practitioner: localStorage.getItem('practitionerId'),
        treatment: localStorage.getItem('treatmentId'),
        prepayDate: new Date(),
        description: null
      };
    } else {
      this.postOptions.url = `/online-booking/invoice/pay/${JSON.parse(localStorage.getItem('Appointment')).eventId}?token=${JSON.parse(localStorage.getItem('cardToken')).id}`;
      this.postOptions.body = {
        practitioner: localStorage.getItem('practitionerId'),
        invoiceItems: [
          {
            itemCount: 1,
            discount: 0,
            inventoryAndPriceListId: JSON.parse(localStorage.getItem('data')).price.id
          }
        ]
      };
    }
    this.requestService.post<PostCredentialsRequest, PostCredentialsResponse>(this.postOptions);

    this.store.dispatch({
      type: BOOKING_REQUEST_SUCCESS,
      payload: {
        settings: response['settings'],
        requestUrl: false
      }
    });

    }

  // success for delete
  public successDelete(response: DeleteCredentialsResponse): void {
    this.store.dispatch({ type: OVERLAY_FINISH });
    this.store.dispatch({
      type: INFO_DATA_SEND_SUCCESS,
      payload: {
        customer: null
      }
    });
  }
  // success for get
  public successGet(response: GetCredentialsResponse): void {
    this.store.dispatch({ type: OVERLAY_FINISH });
    this.store.dispatch({
      type: INFO_DATA_SEND_SUCCESS,
      payload: {
        customer: response.customer
      }
    });
  }

  public success(response: PostCredentialsResponse): void {
    if (this.actionName.success === 'INFO_DATA_SEND_SUCCESS') {
      this.store.dispatch({ type: OVERLAY_FINISH });
      this.store.dispatch({
        type: LOGIN_REQUEST,
        payload: {
          username: localStorage.getItem('RegistrationUserName'),
          password: localStorage.getItem('RegistrationUserPassword')
        }
      });
    } else {
      if (this.actionName.data) {
        // continue saving card
        this.store.dispatch({
          type: this.actionName.success,
          payload: {
            type: 'post',
            data: response.token.id
          }
        });
        this.store.dispatch({
          type: INFO_DATA_SEND_SUCCESS,
          payload: {
            token: response.token.id
          }
         });
      } else if (this.actionName.pay) {
        // clear data after payment
        this.store.dispatch({ type: OVERLAY_FINISH });
        this.router.navigate([localStorage.getItem('AppId') + '/confirmed']);
        localStorage.removeItem('data');
        localStorage.removeItem('clinicId');
        localStorage.removeItem('treatmentPractitioners');
        localStorage.removeItem('goToTreatment');
        localStorage.removeItem('practitionerId');
        localStorage.removeItem('Appointment');
        localStorage.removeItem('treatmentId');
        localStorage.removeItem('treatmentTime');
        localStorage.removeItem('cardToken');
        this.store.dispatch({ type: this.actionName.success, payload: { token: null } });
      } else {
        this.store.dispatch({ type: OVERLAY_FINISH });
        this.store.dispatch({ type: this.actionName.success });
      }
    }
  }
  // error handler
  public error(httpErrorResponse: HttpErrorResponse): void {
    this.store.dispatch({ type: OVERLAY_FINISH });
    this.store.dispatch({
      type: INFO_UPDATE,
      payload: { cardValidationProccess: true }
    });
    console.error('Look At This Error', HttpErrorResponse);
    if (!httpErrorResponse.url.endsWith('/customer')) {
      this.openDialog({status: 'Error', message: httpErrorResponse.error ?
      httpErrorResponse.error.error ? httpErrorResponse.error.error.message : httpErrorResponse.error.message :
      httpErrorResponse.message});
    }
    if (this.actionName.pay && !navigator.onLine) {
      this.router.navigate([localStorage.getItem('AppId') + '/cabinet']);
      localStorage.removeItem('data');
      localStorage.removeItem('clinicId');
      localStorage.removeItem('treatmentPractitioners');
      localStorage.removeItem('goToTreatment');
      localStorage.removeItem('practitionerId');
      localStorage.removeItem('Appointment');
      localStorage.removeItem('treatmentId');
      localStorage.removeItem('treatmentTime');
    }
    this.store.dispatch({
      type: this.actionName.failure,
      payload: {
        error: httpErrorResponse
      }
    });
  }
  // open angular material dialog
  private openDialog(message: any): void {
    if (message) {
      const dialogRef = this.dialog.open(ErrorComponent, {
        width: '90%',
        data: message
      });
    } else {
      const dialogRef = this.dialog.open(ModalComponent, {
        width: '90%'
      });
    }
  }

  // payment requests
  @Effect()
  public info$: Observable<any> = this.actions$
    .ofType(INFO_PAYMENT)
    .map((action: InfoAction) => action)
    .mergeMap(state => {
      this.actionName = {
        success: 'INFO_PAYMENT_SUCCESS',
        failure: 'INFO_PAYMENT_FAILURE'
      };
        if (state.payload['type'] === 'payment') {
        this.getOptionsToCheckRequest.url = `/online-booking/${localStorage.getItem('AppId')}/settings`;
        this.requestService.get<GetCredentialsResponse>(this.getOptionsToCheckRequest);
      } else if (state.payload['type'] === 'get') {
        this.requestService.get<GetCredentialsResponse>(this.getOptions);
      }
      return Observable.of({
        type: 'INFO_PAYMENT_PROCESSING'
      });
    });
  // password set request
  @Effect()
  public infoData$: Observable<any> = this.actions$
    .ofType(INFO_DATA_SEND)
    .map((action: InfoAction) => action)
    .mergeMap(state => {
      this.actionName = {
        success: 'INFO_DATA_SEND_SUCCESS',
        failure: 'INFO_DATA_SEND_FAILURE'
      };
      localStorage.setItem('RegistrationUserPassword', state.payload['data']);
      this.putOptions.body.password = state.payload['data'];
      this.requestService.put<PutCredentialsRequest, PutCredentialsResponse>(this.putOptions);
      return Observable.of({
        type: 'INFO_DATA_SEND_PROCESSING'
      });
    });
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/effects/info.effect.ts